var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.1 187.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 0,
    y1: 93.55,
    x2: 187.1,
    y2: 93.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006496"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.55,187.1C41.97,187.1,0,145.14,0,93.55S41.97,0,93.55,0s93.55,41.97,93.55,93.55-41.97,93.55-93.55,93.55Zm0-178.76C46.57,8.34,8.34,46.57,8.34,93.55s38.22,85.21,85.21,85.21,85.21-38.22,85.21-85.21S140.54,8.34,93.55,8.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.86,54.68c-18.47,0-33.62,14.62-33.62,32.42,0,14.22,20.33,37.74,29.1,47.31,1.2,1.33,2.79,1.99,4.52,1.99s3.32-.66,4.52-1.99c8.77-9.43,29.1-33.09,29.1-47.31,0-17.94-15.15-32.42-33.62-32.42Zm1.06,76.54c-.66,.66-1.59,.66-2.13,0-6.51-7.04-27.91-31.23-27.91-44.12,0-15.41,13.02-27.77,28.97-27.77s28.97,12.49,28.97,27.77c0,12.89-21.39,36.94-27.91,44.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,73.81c-7.84,0-14.35,6.38-14.35,14.35s6.38,14.35,14.35,14.35,14.35-6.38,14.35-14.35-6.51-14.35-14.35-14.35Zm0,23.92c-5.32,0-9.7-4.39-9.7-9.7s4.39-9.7,9.7-9.7,9.7,4.39,9.7,9.7-4.39,9.7-9.7,9.7Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/ubicacion.eab51badd9485645fbef4a24ab02f51c.svg";
export { ForwardRef as ReactComponent };